export class Synchronized {
    mutex;
    constructor(mutex) {
        this.mutex = mutex;
    }
    checkWasmReentrance() {
        if (!this.mutex.isLocked()) {
            throw new Error('Wasm module is not reentrant!');
        }
    }
}
